import React, { Component } from 'react'

import UrgencesPage from '../containers/UrgencesPage'
import PrimaryLayout from '../components/layouts/PrimaryLayout'
import pagesInfos from '../config/i18n/pagesInfos'

const Urgences = ({ pageContext }) => {
  return (
    <PrimaryLayout
      language={pageContext.language}
      isDisplayFromHome={false}
      page={pagesInfos.ComponentUrgences}
    >
      <UrgencesPage />
    </PrimaryLayout>
  )
}

export default Urgences
